import "@fontsource-variable/manrope"
import "@fontsource-variable/inter"
import "@hotwired/turbo-rails"
import "trix"
import "trix/dist/trix.css"
import "./trix_overrides.css"
import "./controllers"
import ahoy from "./analytics"

ahoy.trackView()
